export default {
  'app.org.title': 'Organizations',
  'app.org.column.id': 'Organization ID',
  'app.org.column.name': 'Organization Name',
  'app.org.column.timezone': 'Timezone',
  'app.org.column.website': 'URL',
  'app.org.column.isCreator': 'Creator',
  'app.org.column.createTime': 'Create Time',
  'app.org.column.operate': 'Operate',
  'app.org.column.operate.enter': 'Enter',
  'app.org.column.operate.edit': 'Edit',
  'app.org.column.operate.delete': 'Delete',
  'app.org.column.operate.placeholder': 'please enter organization Name/ organization ID',
  'app.org.create': 'Create an organization',
  'app.org.create.submit': 'Create an organization',
  'app.org.bind.tip': 'Create an organization',
  'app.org.create.tip': 'Already organized ?',
  'app.org.create.tip.bind': 'to bind',
  'app.org.success.tip': 'Back To Console',
  'app.org.bind': 'Bind an organization',
  'app.org.bind.submit': 'Finish Bind',
  'app.org.create.create': 'Create',
  'app.org.create.cancel': 'Cancel',
  'app.org.create.save': 'Save',
  'app.org.create.profile': 'Organization Profile',
  'app.org.create.name.placeholder': 'Enter the organization name',
  'app.org.create.website.placeholder': 'Enter a URL (top-level domain)',
  'app.org.create.timezone': 'Timezone',
  'app.org.create.timezone.tip': '( Once selected, it cannot be changed )',
  'app.org.create.currency': 'Currency',
  'app.org.create.usd': 'USD',
  'app.org.create.success': 'Created successfully',
  'app.org.edit.success': 'Edit successfully',
  'app.org.rule.blank': 'This field cannot be blank',
  'app.org.rule.char': 'Illegal characters are not allowed in the character name',
  'app.org.rule.name.exists': 'The organization name already exists',
  'app.org.rule.url.exists': 'The URL already exists',
  'app.org.rule.url.start': 'Please enter a URL starting with www',
  'app.org.delete.title': 'Delete Organization',
  'app.org.delete.content':
    'Warning! Deleting your organization is irreversible. It will permanently delete data and information such as users, businesses, balances, bills, orders and interests of this organization, and all related services will be terminated.',
  'app.org.delete.warn': 'When there is supplementary to be paid, your account cannot be deleted!',
  'app.org.delete.cancel': 'Cancel',
  'app.org.delete.next': 'Next',
  'app.org.delete.delete': 'Delete',
  'app.org.delete.confirm': 'Confirm the deletion',
  'app.org.delete.confirm.content':
    'Before your account deletion takes effect, we will verify your account as follows . Please find the verification code in the email.',
  'app.org.delete.confirm.send': 'Send verification code',
  'app.org.delete.confirm.send.resend': 'Resend verification code',
  'app.org.delete.confirm.resend': 'Resend',
  'app.org.delete.confirm.rule': 'Please enter the correct verification',
  'app.org.delete.success': 'Delete successfully',
  'app.org.delete.balance': 'This organization has balance and cannot be deleted.',
};
